import * as constants from './constants';

export interface IOpenChangePassword {
  type: constants.OPEN_CHANGE_PASSWORD;
}

export interface ICloseChangePassword {
  type: constants.CLOSE_CHANGE_PASSWORD;
}

export interface IOpenDeleteDialog {
  type: constants.OPEN_DELETE_DIALOG;
}

export interface ICloseDeleteDialog {
  type: constants.CLOSE_DELETE_DIALOG;
}

export type PopupAction = IOpenChangePassword | ICloseChangePassword | IOpenDeleteDialog | ICloseDeleteDialog;

export const openChangePassword = (): IOpenChangePassword => {
  return {
    type: constants.OPEN_CHANGE_PASSWORD
  }
}

export const closeChangePassword = (): ICloseChangePassword => {
  return {
    type: constants.CLOSE_CHANGE_PASSWORD
  }
}

export const openDeleteDialog = (): IOpenDeleteDialog => {
  return {
    type: constants.OPEN_DELETE_DIALOG
  };
};
  
export const closeDeleteDialog = (): ICloseDeleteDialog => {
  return {
    type: constants.CLOSE_DELETE_DIALOG
  };
};


// WEBPACK FOOTER //
// ./src/modules/popup/action.ts